import styles from '../styles/LocationSearch.module.scss'

export default function NearByBtn({ onClick }) {
  return (
    <a className={styles.nearByBtn} onClick={onClick}>
      <i className='padi-icons padi-icons--search' />
    </a>
  )
}
